// Mock API only (the Test tools panel): answer for Meta on a pending template ("approved" / "rejected"). For real, the vendor's callback
// tells us. Approving a marketing template without STOP is refused by the API.
import { notify } from '@the-kit/ui'
import type { Template } from '@/api/schemas'
import { errorText } from '@/lib/format'
import { useSimulateTemplateDecision } from '../hooks'

export function SimulateMetaButtons({ template }: { template: Template }) {
  const decide = useSimulateTemplateDecision()
  if (template.status !== 'pending') return null
  const answer = (decision: 'approved' | 'rejected') =>
    decide.mutate(
      { id: template.id, decision },
      {
        onSuccess: () => notify.info('Meta (simulated)', `${template.name} ${decision}`),
        onError: (error) => notify.error('Not done', errorText(error)),
      }
    )
  return (
    <span className="flex gap-1">
      <button
        type="button"
        className="btn btn-ghost btn-sm"
        onClick={() => answer('approved')}
        data-testid={'simulate-approve-' + template.name}
      >
        Simulate: Meta approved
      </button>
      <button
        type="button"
        className="btn btn-ghost btn-sm"
        onClick={() => answer('rejected')}
        data-testid={'simulate-reject-' + template.name}
      >
        Simulate: rejected
      </button>
    </span>
  )
}
